import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileBar } from "@/components/MobileBar";
import { SmoothScroll } from "@/components/fx/SmoothScroll";
import { Hero } from "@/components/sections/Hero";
import { Problem } from "@/components/sections/Problem";
import { Metodo } from "@/components/sections/Metodo";
import { Confronto } from "@/components/sections/Confronto";
import { Ruoli } from "@/components/sections/Ruoli";
import { Risultati } from "@/components/sections/Risultati";
import { Pagamento } from "@/components/sections/Pagamento";
import { FormSection } from "@/components/sections/FormSection";
import { Faq } from "@/components/sections/Faq";
import { setCanonical } from "@/lib/seo";
import { scrollToId } from "@/lib/motion";

export default function Home() {
  useEffect(() => {
    document.title = "Trovare personale per la tua PMI | Recruiting Lab Italia";
    setCanonical("/");
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => scrollToId(id), 600);
    }
  }, []);
  return (
    <div className="relative" data-testid="home-page">
      <a href="#richiedi" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-white focus:px-4 focus:py-2">
        Vai al modulo di richiesta
      </a>
      <SmoothScroll />
      <Header />
      <main>
        <Hero eyebrow="Trovare personale per PMI · Candidati per aziende in tutta Italia" />
        <Problem />
        <Metodo />
        <Confronto />
        <Ruoli />
        <Risultati />
        <Pagamento />
        <FormSection />
        <Faq />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
